import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { useTranslation } from '../contexts/LocaleContext';

interface BackButtonProps {
  /** Маршрут, на который перейти, если в истории некуда возвращаться */
  fallbackRoute: string;
  className?: string;
}

/** Кнопка «Назад»: возврат по истории или переход на fallbackRoute */
export const BackButton: React.FC<BackButtonProps> = ({ fallbackRoute, className }) => {
  const navigate = useNavigate();
  const t = useTranslation();
  return (
    <Button
      variant="link"
      className={`text-secondary text-decoration-none p-0 align-baseline ${className ?? ''}`}
      onClick={() => {
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          navigate(fallbackRoute);
        }
      }}
    >
      ← {t('manage.back')}
    </Button>
  );
};

export default BackButton;
